import extend from "lodash/extend";
import { QueryResult } from "lib/results/types";
import { VisualCounter } from "lib/visuals/types";
import { resultPrimitive } from "lib/results/values";
import { isDefined } from "lib/types/types";

export const formatCounterLabel = (visual: VisualCounter) => {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  return visual.options.counterLabel || visual.name || "";
};

export const getCounterValue = (
  visual: VisualCounter,
  result?: QueryResult
) => {
  const rows = result?.matrix?.rows ?? [];
  const rowNumber = wrapRowNumber(visual.options.rowNumber ?? 0, rows.length);
  const { countRow = false, counterColName: colName } = visual.options;

  const value =
    countRow && isDefined(colName)
      ? rows.length
      : isDefined(rows[rowNumber]) &&
        isDefined(colName) &&
        isDefined(resultPrimitive(rows[rowNumber][colName]))
      ? resultPrimitive(rows[rowNumber][colName])
      : null;

  return value;
};

export const formatCounterValue = (
  visual: VisualCounter,
  value: number | string | null
) => {
  if (value === null) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  const options = extend({}, defaultOptions, visual.options);
  const stringPrefix = (options.stringPrefix ?? "").trimLeft();
  const stringSuffix = (options.stringSuffix ?? "").trimRight();

  if (options.stringDecimal || options.stringDecChar || options.stringThouSep) {
    const decimals = Math.max(options.stringDecimal, 0);
    const parts = value.toFixed(decimals).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, options.stringThouSep);
    value = parts.join(options.stringDecChar || ".");
  }

  return stringPrefix + value + stringSuffix;
};

const wrapRowNumber = (index: number, size: number) => {
  if (index >= 0) {
    return index - 1;
  }

  if (Math.abs(index) > size) {
    index %= size;
  }

  return size + index;
};

const defaultOptions = {
  counterColName: "counter",
  rowNumber: 1,
  targetRowNumber: 1,
  stringDecimal: 0,
  stringDecChar: ".",
  stringThouSep: ",",
  defaultColumns: 2,
  defaultRows: 5,
};
